class productTabs extends HTMLElement {
  static get observedAttributes() {
    return ['data-active-tab'];
  }
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('.tab_title');
    this.tabs = this.querySelectorAll('.product-tab');
    this.accordions = document.querySelectorAll('.product-details accordion-tab');
  }

  get activeTab() {
    return this.dataset.activeTab
  }

  attributeChangedCallback(name, oldValue, newValue) {    
      if (name === 'data-active-tab' && oldValue !== newValue) {
        this.setActiveTab();
    }
  }

  connectedCallback() {
    this.hideAccordions();
    this.openTab();
  }

  openTab() {
    this.tabButtons.forEach(buttton => {
      buttton.addEventListener('click', ()=> {
        this.dataset.activeTab = buttton.dataset.tab;
      })
    })    
  }

  setActiveTab() {
    this.tabs.forEach(el => {
      el.dataset.tab === this.activeTab ? el.classList.add('active') : el.classList.remove('active');
    })

    this.tabButtons.forEach(button => {
      button.dataset.tab === this.activeTab ? button.classList.add('active') : button.classList.remove('active');
    })
  }

  hideAccordions() {
    if(this.accordions.length > 0 && window.innerWidth < 990) {
      this.tabs.forEach(tab => {
        this.accordions.forEach(accordion => {
          const content =  accordion.querySelector('.accordion__content');
          const nutrition = accordion.querySelector('.nutrition');
          const nutritionTab = tab.querySelector('.nutrition-tab');
  
          
          
          if (content) {
            if(tab.innerHTML === content.innerHTML) {
              accordion.style.display = 'none';
            }
            const tabMetafieldValue = tab.querySelector('.metafield-rich_text_field');
            const metafieldValue = content.querySelector('.metafield-rich_text_field');

            if(tabMetafieldValue && metafieldValue) {
              if(tabMetafieldValue.innerHTML === metafieldValue.innerHTML) {
                accordion.style.display = 'none';
              }
            }
          }

          if (nutrition && nutritionTab) {
            if(nutritionTab.innerHTML === nutrition.innerHTML) {
              accordion.style.display = 'none';
            }
          }
        })
      })
    }
  }
}

customElements.define('product-tabs', productTabs)